var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('exclusive-offer-toast',{staticClass:"added-to-cart-toast",attrs:{"success":"","message":_vm.message,"event":_vm.event,"button-text":_vm.viewCartButtonText,"button-click-url":_vm.secondaryactionurl}})}
var staticRenderFns = []

export { render, staticRenderFns }